import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import { replaceCurrentSignup } from '../../modules/signupEdit/actions'
import submitMsp from './submitMsp'

export default function* handleSubmitMsp(apis) {
  let state = yield effects.select()
  let signup = state.signupEdit.get('edit')

  const success = yield effects.call(submitMsp, apis, signup)
  if (!success) {
    return
  }

  state = yield effects.select()
  signup = state.signupEdit.get('edit')

  yield effects.put.resolve(replaceCurrentSignup(null))
  yield effects.put.resolve(pushPath(`/partner/finished/${signup.reference}`))

  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/handleSubmitMsp.js